import type { ComponentChildren } from 'preact';
import { AuthProvider } from '@vendidit/auth-client/preact';
import sdkPkg from '@vendidit/auth-client/package.json';
import { auth, demoConfig } from '../auth-client-config.js';
import { Header } from './Header.js';

/**
 * Outermost wrapper — mounts the AuthProvider with the shared demo
 * AuthClient so every component subtree (including the SDK's own UI
 * components) reads from the same snapshot.
 *
 * Footer compiles the build mode + SDK version + backend URL at build
 * time. `import.meta.env.MODE` is replaced by Vite during the build
 * (one of 'production' / 'development' / a custom mode); the SDK
 * version is read from its `package.json` via Vite's `resolveJsonModule`
 * support, so a `pnpm install` of a newer SDK is reflected on the next
 * demo build.
 */
const sdkVersion = (sdkPkg as { version?: string }).version ?? 'unknown';
const buildMode = import.meta.env.MODE;

export function AppShell(props: { children: ComponentChildren }) {
    return (
        <AuthProvider client={auth}>
            <div class="demo-app">
                <Header />
                <main class="demo-main">{props.children}</main>
                <footer class="demo-footer">
                    <code>@vendidit/auth-client v{sdkVersion}</code>
                    {' · '}
                    <code>{demoConfig.apiBaseUrl}</code>
                    {' · '}
                    <span class={`demo-footer-mode demo-footer-mode-${buildMode}`}>{buildMode}</span>
                </footer>
            </div>
        </AuthProvider>
    );
}
